/* eslint-disable import/prefer-default-export */
import { css } from "@emotion/react";
import { columnGap8Css } from "assets/css/gaps.css";

export const pagesInfoCss = [
  columnGap8Css,
  css`
    display: inline-grid;
    grid-template-columns: 1fr auto 1fr;
    justify-items: end;
  `,
];
